<div class="ui-tabview ui-tabview-top">
  <div class="ui-tabview-nav form-group search" style="border-bottom: none;">
    <i class="material-icons search-before">&#xE8B6;</i>
    <input id="search" name="search" type="text" [(ngModel)]="filterParameter" class="form-control" [placeholder]="placeholder" autocomplete="off" (keyup)="search()" />
    <button class="btn btn-link" id="resetSearch" (click)="resetFilter()">
      <i class="material-icons">&#xE5CD;</i>
    </button>
  </div>
</div>
